import axios from 'axios';

export const fetchDivisionList = (countryId: number, tenantId: number) =>
  axios({
    method: 'POST',
    url: '/admin-service/division/division-list',
    data: {
      countryId,
      tenantId
    }
  });
